import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";

export const VagasDisponiveisAba = ({ children, props }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Vagas Disponíveis
        </Text>
        {children}
      </Flex>

      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Vagas Disponíveis?"}
          mb={4}
        >
          Possui Vagas Disponíveis?
        </Text>
        <Field name="possuiVaga">
          {({ field, form }) => (
            <FormControl
              isInvalid={form.errors.possuiVaga && form.touched.possuiVaga}
              id="possuiVaga"
              width="max-content"
              zIndex={"1"}
            >
              <RadioGroup
                value={field.value}
                onChange={(value) => props.setFieldValue("possuiVaga", value)}
              >
                <Stack direction="row">
                  <RadioButtonField
                    id="possui-vaga-sim"
                    fieldName="possuiVaga"
                    value="S"
                    label="Sim"
                  />
                  <RadioButtonField
                    id="possui-vaga-nao"
                    fieldName="possuiVaga"
                    value="N"
                    label="Não"
                  />
                </Stack>
              </RadioGroup>
              <FormErrorMessage mt="-1" mr="-16">
                {form.errors.possuiVaga}
              </FormErrorMessage>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
